import {type MutationTree} from 'vuex';

function set(reference: object, key: string | number, value: string | string[] | boolean | undefined)
{
    if (typeof value === 'undefined')
    {
        delete reference[key];
    }
    else
    {
        reference[key] = value;
    }
}

// mutations
const mutations: MutationTree<FormState> = {
    reset(state)
    {
        state.errors    = {};
        state.filter    = {};
        state.validated = {};
        state.submitted = false;
    },
    resetErrors(state, errorName)
    {
        delete state.errors[errorName];
        delete state.validated[errorName];
    },
    resetAllErrors(state)
    {
        state.errors    = {};
        state.validated = {};
        state.submitted = false;
    },
    setError(state, {errorName, errors})
    {
        if (Array.isArray(errors) && errors.length)
        {
            state.errors[errorName] = errors;
        }
        else
        {
            delete state.errors[errorName];
        }

        state.validated[errorName] = true;
    },
    setErrors(state, formattedErrors)
    {
        state.errors = formattedErrors;
    },
    setFilter(state, filter)
    {
        state.filter = filter;
    },
    setSubmitted(state)
    {
        state.submitted = true;
    },
    swapErrors(state, {from, to})
    {
        // preserve values from "to"
        let swapErrorTo     = state.errors[to];
        let swapValidatedTo = state.validated[to];

        // set "to" to "from"
        set(state.errors, to, state.errors[from]);
        set(state.validated, to, state.validated[from]);

        // set "from" to previously preserved "to"
        set(state.errors, from, swapErrorTo);
        set(state.validated, from, swapValidatedTo);
    },
    setErrorsAndValidated(state, {errorName, errors, validated})
    {
        set(state.errors, errorName, errors);
        set(state.validated, errorName, validated);
    },
};

export default mutations;